import {DEV_MODE_LOG_CONFIG, IS_DEV_MODE, URL_HOST} from '@/constants/constant';
import {WEBSERVER, WEBSERVER_PROD} from '@/constants/routeAPI';

import api from './apiManager';

/**
 * @todo change it into public/webserver.json
 */
const callConfig = async (url) => {
  if (IS_DEV_MODE) return DEV_MODE_LOG_CONFIG;

  const response = await api.get(url);

  return response.data;
};

export const getConfigs = Promise.all([callConfig(IS_DEV_MODE ? WEBSERVER : WEBSERVER_PROD)]);

export const getStateServerAlive = async () => {
  const response = await api.get(URL_HOST);

  if (!response) throw response;

  return response;
};
